define(["../hereMapsModule"],
    function (hereMapsModule) {
        "use strict";

        hereMapsModule.service("hereMapsPolygonDrawingManagerFactory", [
            "hereMapsService",
            function (hereMapsService) {
                var Here = null;
                return {
                    createPolygons: createPolygons,
                    createPolygonGroupWithHoles: createPolygonGroupWithHoles
                };

                function createPolygons(polygonsData) {
                    Here = hereMapsService.getHere();
                    var polygons = polygonsData.polygons;
                    var herePolygons = [];

                    if (!polygons) {
                        return herePolygons;
                    }
                    for (var i = 0; i < polygons.length; i++) {
                        var currentPolygon = polygons[i];
                        var polygon = createPolygon(currentPolygon);
                        herePolygons.push(polygon);
                    }
                    return herePolygons;
                }

                function createPolygon(currentPolygon) {
                    var lineString = getLineString(currentPolygon);

                    var geometry = new Here.geo.Polygon(lineString);
                    return new Here.map.Polygon(geometry, {
                        style: {
                            fillColor: "rgba(139, 225, 198, 0.5)",
                            strokeColor: "#4e7468",
                            lineWidth: 1
                        },
                        data: {
                            editable: currentPolygon.editable
                        }
                    });
                }

                function getLineString(currentPolygon) {
                    var lineString = new Here.geo.LineString();
                    for (var j = 0; j < currentPolygon.points.length; j++) {
                        lineString.pushPoint({
                            lat: currentPolygon.points[j].lat,
                            lng: currentPolygon.points[j].lng
                        });
                    }
                    return lineString;
                }

                function createPolygonGroupWithHoles(polygons, polygonGroupsData) {
                    Here = hereMapsService.getHere();
                    var polygonGroup = new Here.map.Group();

                    polygonGroupsData.polygonGroup = polygonGroup;
                    for (var i = 0; i < polygons.length; i++) {
                        var currentPolygon = polygons[i];
                        var holes = polygonGroupsData.holes;
                        var polygon = createPolygonWithHoles(currentPolygon,
                            holes,
                            polygonGroupsData.color,
                            polygonGroupsData.zIndex,
                            polygonGroupsData);
                        polygonGroup.addObject(polygon);
                    }
                    return polygonGroup;
                }

                function createPolygonWithHoles(currentPolygon, holes, fillColor, zIndex, extraData) {
                    var lineString = getLineString(currentPolygon);
                    var holesLineString = [];

                    for (var i = 0; i < holes.length; i++) {
                        holesLineString.push(getLineString(holes[i]));
                    }

                    var geometry = new Here.geo.Polygon(lineString, holesLineString);

                    var options = {
                        style: {
                            fillColor: "rgba(139, 225, 198, 0.5)",
                            strokeColor: "#4e7468",
                            lineWidth: 1
                        },
                        data: {
                            editable: currentPolygon.editable
                        }
                    };

                    if (fillColor) {
                        options.style.fillColor = fillColor;
                    }

                    if (typeof zIndex === "number") {
                        options.zIndex = zIndex;
                    }
                    if (extraData) {
                        options.data.model = extraData;
                    }

                    return new Here.map.Polygon(geometry, options);
                }

            }
        ]);
    });